export const constants = {
  INITIAL_ZOOM: 12,
}
